import { ReactComponent as SearchIcon } from "../../assets/search-short-handle.svg";
import { ReactComponent as FilterIcon } from "../../assets/filter-lines.svg";
import { Select, DatePicker, Col, Row, Input, Tooltip, Tag } from "antd";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import dayjs from "dayjs";

import "./filterObligations.css";
import { setOblFilterField } from "../../store/forms/actions";

const FilterObligations = ({
  organizationId,
  sortedUniqueMainCategories,
  obligationType,
  defaultCat
}) => {
  const dispatchito = useDispatch();

  const { Search } = Input;
  const { Option } = Select;
  const { RangePicker } = DatePicker;

  const [firstRender, setFirstRender] = useState(true);
  const [openFilters, setOpenFilters] = useState(false);
  const prefix = <SearchIcon id="search-icon-filters-svg" />;

  const category = useSelector(state => state.forms?.selectedCategory);
  const searchTerm = useSelector(state => state.forms?.searchTerm);
  const action = useSelector(state => state.forms?.selectedAction);
  const assessment = useSelector(state => state.forms?.selectedAssessment);
  const dueDateFrom = useSelector(state => state.forms?.dueDateFrom);
  const dueDateTo = useSelector(state => state.forms?.dueDateTo);

  const tagColors = {
    Pending: { colorBack: "#F4F4F4", colorFont: "#4F4F4F" },
    Partially: { colorBack: "#FDF9F2", colorFont: "#F3A156" },
    Compliant: { colorBack: "#ECFDF3", colorFont: "#027A48" },
    "Non-Compliant": { colorBack: "#FDF2F2", colorFont: "#EB5A5A" },
    na: { colorBack: "#F4F4F4", colorFont: "#4F4F4F" }
  };

  const onCategoryChange = value => {
    dispatchito(setOblFilterField({ key: "selectedCategory", value: value }));
  };

  const setSearchTerm = value => {
    dispatchito(setOblFilterField({ key: "searchTerm", value: value }));
  };

  const onChangeDate = dates => {
    // console.debug("RANGE", e);
    let from =
      dates && dates[0]
        ? dates[0]?.$y +
          "-" +
          (dates[0]?.$M + 1).toString().padStart(2, "0") +
          "-" +
          dates[0]?.$D.toString().padStart(2, "0")
        : "";
    let to =
      dates && dates[1]
        ? dates[1]?.$y +
          "-" +
          (dates[1]?.$M + 1).toString().padStart(2, "0") +
          "-" +
          dates[1]?.$D.toString().padStart(2, "0")
        : "";
    // console.debug("RANGE change on date", from, to);
    dispatchito(setOblFilterField({ key: "dueDateFrom", value: from }));
    dispatchito(setOblFilterField({ key: "dueDateTo", value: to }));
  };

  const categoryExistsInOrg = cat => {
    const foundCategory = sortedUniqueMainCategories?.some(
      item => item?.value === cat
    );
    return foundCategory;
  };

  const tagRender = props => {
    const { label, value, closable, onClose } = props;
    const onPreventMouseDown = event => {
      event.preventDefault();
      event.stopPropagation();
    };
    return (
      <Tag
        color={tagColors?.[value]?.colorBack}
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
        className="filter-assessment-tag"
        style={{
          marginInlineEnd: 4,
          fontWeight: 500,
          fontFamily: "Roboto",
          fontSize: "0.75rem",
          color: tagColors?.[value]?.colorFont,
          borderRadius: "1rem",
          "& .ant-tag-close-icon": {
            color: tagColors?.[value]?.colorFont
          }
        }}
      >
        {label}
      </Tag>
    );
  };

  const initializations = () => {
    if (defaultCat && categoryExistsInOrg(defaultCat)) {
      dispatchito(
        setOblFilterField({ key: "selectedCategory", value: defaultCat })
      );
    } else {
      dispatchito(setOblFilterField({ key: "selectedCategory", value: null }));
    }
    dispatchito(
      setOblFilterField({ key: "obligationType", value: obligationType })
    );
    dispatchito(setOblFilterField({ key: "searchTerm", value: "" }));
    dispatchito(setOblFilterField({ key: "selectedAction", value: null }));
    dispatchito(setOblFilterField({ key: "selectedAssessment", value: [] }));
    dispatchito(setOblFilterField({ key: "dueDateFrom", value: "" }));
    dispatchito(setOblFilterField({ key: "dueDateTo", value: "" }));
  };

  useEffect(() => {
    initializations();
    setFirstRender(false);
  }, []);

  useEffect(() => {
    if (!firstRender) {
      initializations();
    }
  }, [organizationId]); //firstRender is not included on purpose

  return (
    <>
      <Row
        className="filters-1st-row"
        id="ob-page-rows"
        gutter={{ xs: 8, sm: 12, md: 24, lg: 22 }}
      >
        <Col span={5}>
          <Select
            virtual={false}
            defaultValue={defaultCat}
            popupClassName="category-selector"
            value={category}
            allowClear
            id="complianceCat"
            placeholder="Select Category"
            size="large"
            onChange={onCategoryChange}
            className="gauge-select mb-2"
          >
            {sortedUniqueMainCategories?.map((item, index) => {
              return (
                <Option key={item.value} value={item.value}>
                  {item.label}
                </Option>
              );
            })}
          </Select>
        </Col>
        <Col span={17}>
          {" "}
          <Search
            className="filters-search-bar"
            id={"filters-search-bar"}
            placeholder={`Search by ${
              obligationType === "main" ? "Law, " : ""
            }Obligation, ID`}
            prefix={prefix}
            allowClear
            size="large"
            value={searchTerm}
            onSearch={e => setSearchTerm(e)}
            onChange={e => setSearchTerm(e.target.value)}
          />
        </Col>
        <Col span={2} className="filter-icon">
          <Tooltip
            title={openFilters ? 
              <>
                Click here
                <br />
                to hide the filters
              </> 
              :
              <>
                Click here
                <br />
                to show the filters
              </>
            }
            arrow={true}
            color={"#FFFFFF"}
            overlayClassName="filter-tooltip"
            placement="top"
          >
            <FilterIcon
              onClick={() => setOpenFilters(!openFilters)}
              style={{ marginTop: "0.5rem", cursor:"pointer" }}
            />
          </Tooltip>
        </Col>
      </Row>
      <Row
        style={{
          borderTop: openFilters ? "none" : "1px solid #E2E2E2",
          marginBottom: openFilters ? "0" : "2rem",
          marginTop: openFilters ? "0" : "1rem"
        }}
      ></Row>
      <Row
        className="filters-2nd-row"
        gutter={[16, 0]}
        style={{ display: openFilters ? "flex" : "none" }}
      >
        <Col span={5}></Col>
        <Col span={2}>
          <Select
            className="action-select-filter row-2-filter"
            popupClassName="obl-filter-select-dropdown"
            id={`ob_action_filter`}
            allowClear
            onChange={value =>
              dispatchito(setOblFilterField({ key: "selectedAction", value }))
            }
            placeholder="Action"
            value={action}
          >
            <Select.Option value="Pending">Pending</Select.Option>
            <Select.Option value="Completed">Completed</Select.Option>
          </Select>
        </Col>
        <Col span={6}>
          <Select
            virtual={false}
            mode="multiple"
            id={`ob_as_filter`}
            closable
            allowClear
            tagRender={option => tagRender(option)}
            placeholder="Assessment"
            className="assessment-select-filter row-2-filter"
            popupClassName="obl-filter-select-dropdown"
            onChange={value => {
              dispatchito(
                setOblFilterField({ key: "selectedAssessment", value })
              );
            }}
            value={assessment}
            options={[
              {
                value: "Pending",
                label: "Pending"
              },
              {
                value: "Partially",
                label: "Partially Compliant"
              },
              {
                value: "Compliant",
                label: "Compliant"
              },
              {
                value: "Non-Compliant",
                label: "Non Compliant"
              },
              {
                value: "na",
                label: "N/A"
              }
            ]}
          />
        </Col>
        <Col span={6} id="dueDate-filter-col">
          <RangePicker
            id="obligations-range-picker"
            className="row-2-filter"
            onChange={onChangeDate}
            format={"DD/MM/YYYY"}
            placeholder={["From", "To"]}
            allowEmpty={[true, true]}
            value={[
              dueDateFrom ? dayjs(dueDateFrom, "YYYY-MM-DD") : null,
              dueDateTo ? dayjs(dueDateTo, "YYYY-MM-DD") : null
            ]}
          />
        </Col>
        <Col span={5}></Col>
      </Row>
    </>
  );
};

export default FilterObligations;
